import * as t from 'io-ts';

export const JwtTokenSchema = t.exact(t.interface({
    token: t.string,
}));

export interface JwtToken extends t.TypeOf<typeof JwtTokenSchema> {}
